import { pageFilter, setSearchParam } from "./overview-filter-state";
import {search} from "./overview-filters";

export const registerPaginationTriggers = () => {
	let paginationButtons = document.querySelectorAll('button.pagination[data-pagination-page]:not([disabled])');

	paginationButtons.forEach(button => {
		const page = button.getAttribute("data-pagination-page");
		button.addEventListener('click', async () => {
			setSearchParam(pageFilter.page, page);
			await search(true, false, false);
		});
	});
}
